import { ObjectData, Winery } from "..";

export class WineryBuilder {

    private _country: null | number;
    private _region: null | ObjectData;
    private _subregion: null | ObjectData;
    private _appellation: null | ObjectData;
    private _domain: null | string;
    private _classification: null | ObjectData;
    private _producer: null | string;
    private _addressStreet: null | string;
    private _addressCity: null | string;
    private _addressPostalCode: null | string;
    private _addressPost: null | string;
    private _latitude: null | number;
    private _longitude: null | number;
    private _phone: null | string;
    private _email: null | string;
    private _website: null | string;
    private _visitingHoursMondayFrom: null | string;
    private _visitingHoursMondayTo: null | string;
    private _visitingHoursTuesdayFrom: null | string;
    private _visitingHoursTuesdayTo: null | string;
    private _visitingHoursWednesdayFrom: null | string;
    private _visitingHoursWednesdayTo: null | string;
    private _visitingHoursThursdayFrom: null | string;
    private _visitingHoursThursdayTo: null | string;
    private _visitingHoursFridayFrom: null | string;
    private _visitingHoursFridayTo: null | string;
    private _visitingHoursSaturdayFrom: null | string;
    private _visitingHoursSaturdayTo: null | string;
    private _visitingHoursSundayFrom: null | string;
    private _visitingHoursSundayTo: null | string;
    private _appointmentOnly: null | boolean;
    private _plantation: null | number;
    private _redVarieties: ObjectData[];
    private _whiteVarieties: ObjectData[];
    private _labels: ObjectData[];
    private _photos: number[];

    static builder(): WineryBuilder {
        return new WineryBuilder();
    }

    constructor() {
        this._country = null;
        this._region = null;
        this._subregion = null;
        this._appellation = null;
        this._domain = null;
        this._classification = null;
        this._producer = null;
        this._addressStreet = null;
        this._addressCity = null;
        this._addressPostalCode = null;
        this._addressPost = null;
        this._latitude = null;
        this._longitude = null;
        this._phone = null;
        this._email = null;
        this._website = null;
        this._visitingHoursMondayFrom = null;
        this._visitingHoursMondayTo = null;
        this._visitingHoursTuesdayFrom = null;
        this._visitingHoursTuesdayTo = null;
        this._visitingHoursWednesdayFrom = null;
        this._visitingHoursWednesdayTo = null;
        this._visitingHoursThursdayFrom = null;
        this._visitingHoursThursdayTo = null;
        this._visitingHoursFridayFrom = null;
        this._visitingHoursFridayTo = null;
        this._visitingHoursSaturdayFrom = null;
        this._visitingHoursSaturdayTo = null;
        this._visitingHoursSundayFrom = null;
        this._visitingHoursSundayTo = null;
        this._appointmentOnly = false;
        this._plantation = null;
        this._redVarieties = [];
        this._whiteVarieties = [];
        this._labels = [];
        this._photos = [];
    }

    // #region Setters
    setCountry(country: null | number): WineryBuilder {
        this._country = country;
        return this;
    }

    setRegion(region: null | ObjectData): WineryBuilder {
        this._region = region;
        return this;
    }

    setSubregion(subregion: null | ObjectData): WineryBuilder {
        this._subregion = subregion;
        return this;
    }

    setAppellation(appellation: null | ObjectData): WineryBuilder {
        this._appellation = appellation;
        return this;
    }

    setDomain(domain: null | string): WineryBuilder {
        this._domain = domain;
        return this;
    }

    setClassification(classification: null | ObjectData): WineryBuilder {
        this._classification = classification;
        return this;
    }

    setProducer(producer: null | string): WineryBuilder {
        this._producer = producer;
        return this;
    }

    setAddressStreet(addressStreet: null | string): WineryBuilder {
        this._addressStreet = addressStreet;
        return this;
    }

    setAddressCity(addressCity: null | string): WineryBuilder {
        this._addressCity = addressCity;
        return this;
    }

    setAddressPostalCode(addressPostalCode: null | string): WineryBuilder {
        this._addressPostalCode = addressPostalCode;
        return this;
    }

    setAddressPost(addressPost: null | string): WineryBuilder {
        this._addressPost = addressPost;
        return this;
    }

    setLatitude(latitude: null | number): WineryBuilder {
        this._latitude = latitude;
        return this;
    }

    setLongitude(longitude: null | number): WineryBuilder {
        this._longitude = longitude;
        return this;
    }

    setPhone(phone: null | string): WineryBuilder {
        this._phone = phone;
        return this;
    }

    setEmail(email: null | string): WineryBuilder {
        this._email = email;
        return this;
    }

    setWebsite(website: null | string): WineryBuilder {
        this._website = website;
        return this;
    }

    setVisitingHoursMondayFrom(visitingHoursMondayFrom: null | string): WineryBuilder {
        this._visitingHoursMondayFrom = visitingHoursMondayFrom;
        return this;
    }

    setVisitingHoursMondayTo(visitingHoursMondayTo: null | string): WineryBuilder {
        this._visitingHoursMondayTo = visitingHoursMondayTo;
        return this;
    }

    setVisitingHoursTuesdayFrom(visitingHoursTuesdayFrom: null | string): WineryBuilder {
        this._visitingHoursTuesdayFrom = visitingHoursTuesdayFrom;
        return this;
    }

    setVisitingHoursTuesdayTo(visitingHoursTuesdayTo: null | string): WineryBuilder {
        this._visitingHoursTuesdayTo = visitingHoursTuesdayTo;
        return this;
    }

    setVisitingHoursWednesdayFrom(visitingHoursWednesdayFrom: null | string): WineryBuilder {
        this._visitingHoursWednesdayFrom = visitingHoursWednesdayFrom;
        return this;
    }

    setVisitingHoursWednesdayTo(visitingHoursWednesdayTo: null | string): WineryBuilder {
        this._visitingHoursWednesdayTo = visitingHoursWednesdayTo;
        return this;
    }

    setVisitingHoursThursdayFrom(visitingHoursThursdayFrom: null | string): WineryBuilder {
        this._visitingHoursThursdayFrom = visitingHoursThursdayFrom;
        return this;
    }

    setVisitingHoursThursdayTo(visitingHoursThursdayTo: null | string): WineryBuilder {
        this._visitingHoursThursdayTo = visitingHoursThursdayTo;
        return this;
    }

    setVisitingHoursFridayFrom(visitingHoursFridayFrom: null | string): WineryBuilder {
        this._visitingHoursFridayFrom = visitingHoursFridayFrom;
        return this;
    }

    setVisitingHoursFridayTo(visitingHoursFridayTo: null | string): WineryBuilder {
        this._visitingHoursFridayTo = visitingHoursFridayTo;
        return this;
    }

    setVisitingHoursSaturdayFrom(visitingHoursSaturdayFrom: null | string): WineryBuilder {
        this._visitingHoursSaturdayFrom = visitingHoursSaturdayFrom;
        return this;
    }

    setVisitingHoursSaturdayTo(visitingHoursSaturdayTo: null | string): WineryBuilder {
        this._visitingHoursSaturdayTo = visitingHoursSaturdayTo;
        return this;
    }

    setVisitingHoursSundayFrom(visitingHoursSundayFrom: null | string): WineryBuilder {
        this._visitingHoursSundayFrom = visitingHoursSundayFrom;
        return this;
    }

    setVisitingHoursSundayTo(visitingHoursSundayTo: null | string): WineryBuilder {
        this._visitingHoursSundayTo = visitingHoursSundayTo;
        return this;
    }

    setAppointmentOnly(appointmentOnly: boolean): WineryBuilder {
        this._appointmentOnly = appointmentOnly;
        return this;
    }

    setPlantation(plantation: null | number): WineryBuilder {
        this._plantation = plantation;
        return this;
    }

    setRedVarieties(redVarieties: ObjectData[]): WineryBuilder {
        this._redVarieties = redVarieties;
        return this;
    }

    setWhiteVarieties(whiteVarieties: ObjectData[]): WineryBuilder {
        this._whiteVarieties = whiteVarieties;
        return this;
    }

    setLabels(labels: ObjectData[]): WineryBuilder {
        this._labels = labels;
        return this;
    }

    setPhotos(photos: number[]): WineryBuilder {
        this._photos = photos;
        return this;
    }
    // #endregion

    build() {
        let missing = '';
        if (this._country === null) {
            missing = missing + ' country';
        }
        if (this._region === null) {
            missing = missing + ' region';
        }
        if (this._domain === null) {
            missing = missing + ' domain';
        }
        if (this._classification === null) {
            missing = missing + ' classification';
        }
        if (this._appointmentOnly === null) {
            missing = missing + ' appointmentOnly';
        }

        if (missing.length > 0 || this._country === null || this._region === null || this._domain === null
            || this._classification === null || this._appointmentOnly === null) {
            throw Error('Missing required properties:' + missing);
        }

        return new Winery(
            this._country,
            this._region,
            this._subregion,
            this._appellation,
            this._domain,
            this._classification,
            this._producer,
            this._addressStreet,
            this._addressCity,
            this._addressPostalCode,
            this._addressPost,
            this._latitude,
            this._longitude,
            this._phone,
            this._email,
            this._website,
            this._visitingHoursMondayFrom,
            this._visitingHoursMondayTo,
            this._visitingHoursTuesdayFrom,
            this._visitingHoursTuesdayTo,
            this._visitingHoursWednesdayFrom,
            this._visitingHoursWednesdayTo,
            this._visitingHoursThursdayFrom,
            this._visitingHoursThursdayTo,
            this._visitingHoursFridayFrom,
            this._visitingHoursFridayTo,
            this._visitingHoursSaturdayFrom,
            this._visitingHoursSaturdayTo,
            this._visitingHoursSundayFrom,
            this._visitingHoursSundayTo,
            this._appointmentOnly,
            this._plantation,
            this._redVarieties,
            this._whiteVarieties,
            this._labels,
            this._photos
        );
    }
}



// WEBPACK FOOTER //
// ./src/api/request/builder/WineryBuilder.ts